var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviousHover1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comp-nav-previous",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1518",
    "data-name": "Rectangle 1518",
    width: 32,
    height: 32,
    rx: 4,
    fill: "#f6fafb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron_right_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "chevron_right_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M22.6,23.9l1.071-1.071L18.741,17.9l4.929-4.929L22.6,11.9l-6,6Z",
    transform: "translate(-4.6 -1.9)",
    fill: "#227c9d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousHover1);
export default __webpack_public_path__ + "static/media/PreviousHover1.b2590999ff0e54d3cad0f7d001cb4968.svg";
export { ForwardRef as ReactComponent };